import { render, staticRenderFns } from "./ESDetailFees.vue?vue&type=template&id=554ecfba&"
import script from "./ESDetailFees.vue?vue&type=script&lang=js&"
export * from "./ESDetailFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports